import { parse, stringify } from 'shared/utils/query-string';


export default function (videoItem, settings) {
  const { id } = videoItem;
  const { siteUrl, compId } = settings;

  const [host, queryAndHash = ''] = siteUrl.split('?');
  const [query = '', hash = ''] = queryAndHash.split('#');
  const queryParams = parse(query);
  const videoArgs = {
    ...queryParams,
    'wix-vod-video-id': id,
  };

  if (compId) {
    videoArgs['wix-vod-comp-id'] = compId;
  }

  const videoQueryString = stringify(videoArgs);

  return `${host}${videoQueryString}#${hash}`;
}



// WEBPACK FOOTER //
// ./src/shared/utils/get-url-to-video.js